module.exports = __webpack_public_path__ + "img/1f434.eba9125.svg";